import React from "react";

const AldoksFrame = ({
  width,
  height,
  position,
  rotation,
  color,
  isComposite,
  glassCount,
  glassColor,
}) => {
  const thickness = 0.06;
  const count = Number(glassCount);
  const glassWidth = (width - (count - 1) * thickness) / count;

  return (
    <group position={position} rotation={rotation}>
      {/* Çerçeve - Alt */}
      <mesh position={[0, thickness / 2, 0]}>
        <boxGeometry args={[width, thickness, 0.05]} />
        <meshStandardMaterial color={color} />
      </mesh>

      {/* Çerçeve - Üst */}
      <mesh position={[0, height - thickness / 2, 0]}>
        <boxGeometry args={[width, thickness, 0.05]} />
        <meshStandardMaterial color={color} />
      </mesh>

      {/* Çerçeve - Sol */}
      <mesh position={[-width / 2 + thickness / 2, height / 2, 0]}>
        <boxGeometry args={[thickness, height, 0.05]} />
        <meshStandardMaterial color={color} />
      </mesh>

      {/* Çerçeve - Sağ */}
      <mesh position={[width / 2 - thickness / 2, height / 2, 0]}>
        <boxGeometry args={[thickness, height, 0.05]} />
        <meshStandardMaterial color={color} />
      </mesh>

      {/* Camlar ve Ara Profiller */}
      {Array.from({ length: count }).map((_, i) => {
        const startX = -width / 2 + glassWidth / 2 + i * (glassWidth + thickness) ;

        return (
          <group key={`glass-${i}`}>
            {/* Cam */}
            <mesh position={[startX, height / 2, 0]}>
              <boxGeometry args={[glassWidth, height - thickness * 2, 0.01]} />
              <meshStandardMaterial color={isComposite=='1' ? color : glassColor} transparent opacity={isComposite=='1' ? 0.99 : 0.5} />
            </mesh>

            {/* Ara Dikey Profil (sonuncuda yok) */}
            {i < count - 1 && (
              <mesh position={[startX + glassWidth / 2 + thickness / 2, height / 2, 0]}>
                <boxGeometry args={[thickness, height, 0.05]} />
                <meshStandardMaterial color={color} />
              </mesh>
            )}
          </group>
        );
      })}
    </group>
  );
};

export default AldoksFrame;
